import { render, staticRenderFns } from "./ServiceTemplate.vue?vue&type=template&id=76c82a1a&scoped=true&lang=pug"
import script from "./ServiceTemplate.vue?vue&type=script&lang=ts"
export * from "./ServiceTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ServiceTemplate.vue?vue&type=style&index=0&id=76c82a1a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c82a1a",
  null
  
)

export default component.exports